import { Component } from '@angular/core';

@Component({
    selector: 'app-site-visit-meeting',
    templateUrl: './site-visit-meeting.component.html',
    styleUrls: ['./site-visit-meeting.component.scss'],
    standalone: false
})
export class SiteVisitMeetingComponent {

}
